import React, { useEffect, useState } from "react";
import { Button, Menu, Typography, Avatar } from "antd";
import { Link } from "react-router-dom";
import {
  HomeOutlined,
  MoneyCollectOutlined,
  BulbOutlined,
  FundOutlined,
  MenuOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import icon from "../images/goldenBitcoin.svg";

const Navbar = () => {
  const [activeMenu, setActiveMenu] = useState(false);
  // const [screenSize, setScreenSize] = useState(null);

  // useEffect(() => {
  //   const handleResize = () => setScreenSize(window.innerWidth);

  //   window.addEventListener("resize", handleResize);

  //   handleResize();
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  // useEffect(() => {
  //   if (screenSize < 768) {
  //     setActiveMenu(false);
  //   } else {
  //     setActiveMenu(true);
  //   }
  // }, [screenSize]);

  return (
    <div className="nav-container">
      <div className="logo-container">
        <Avatar src={icon} size={60} />
        <Typography.Title level={2} className="logo">
          <Link to="/">CryptoWorld</Link>
        </Typography.Title>
        <Button
          className="menu-control-container"
          onClick={() => setActiveMenu(!activeMenu)}
        >
          {!activeMenu ? <MenuOutlined /> : <CloseOutlined />}
        </Button>
      </div>

      <Menu theme="dark" className="links" id={activeMenu ? "hidden" : ""}>
        <Menu.Item icon={<HomeOutlined />}>
          <Link to="/">Home</Link>
        </Menu.Item>

        <Menu.Item icon={<FundOutlined />}>
          <Link to="/cryptocurrencies">cryptocurrencies</Link>
        </Menu.Item>

        {/* <Menu.Item icon={<MoneyCollectOutlined />}>
            <Link to="/exchanges">Exchanges</Link>
          </Menu.Item> */}

        <Menu.Item icon={<BulbOutlined />}>
          <Link to="/news">news</Link>
        </Menu.Item>
      </Menu>
      {/* </div> */}

      {/* )} */}
    </div>
  );
};

export default Navbar;
